import { createContext } from "react";

import { Channel, ClientResponse } from "@/gen/realtime";

export type ListenFn = (msg: ClientResponse) => void;
type RealtimeContext = {
    addListener: (channel: Channel, fn: ListenFn) => string;
    removeListener: (id: string) => void;
    error: Error | null;
};

export const RealTimeContext = createContext<RealtimeContext | null>(null);
